import { render, staticRenderFns } from "./logsig_3.vue?vue&type=template&id=345534dc&scoped=true&"
import script from "./logsig_3.vue?vue&type=script&lang=js&"
export * from "./logsig_3.vue?vue&type=script&lang=js&"
import style0 from "./logsig_3.vue?vue&type=style&index=0&id=345534dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345534dc",
  null
  
)

export default component.exports